/**
 * Merge BOM connections into one list ordered like Edit Assembly.
 * Subassemblies, parts, and part families share a single `order` space.
 *
 * @param {Array} subAssembliesToAssemblies - assembly→subassembly links (optional)
 * @param {Array} partsToAssemblies - part links (assembly or subassembly)
 * @param {Array} [subAssembliesToSubAssemblies=[]] - parent sub→child sub links
 * @returns {Array<{ itemType: 'subassembly'|'part'|'family', order: number, ... }>}
 */
export function groupItemsForBomTable(
    subAssembliesToAssemblies,
    partsToAssemblies,
    subAssembliesToSubAssemblies = []
) {
    const groupedItems = [];

    if (subAssembliesToAssemblies && Array.isArray(subAssembliesToAssemblies)) {
        subAssembliesToAssemblies.forEach((item) => {
            if (item && item.id) {
                groupedItems.push({
                    ...item,
                    itemType: 'subassembly',
                    dragId: item.id,
                });
            }
        });
    }

    if (subAssembliesToSubAssemblies && Array.isArray(subAssembliesToSubAssemblies)) {
        subAssembliesToSubAssemblies.forEach((item) => {
            if (item && item.id) {
                groupedItems.push({
                    ...item,
                    itemType: 'subassembly',
                    dragId: item.id,
                    isSubAssemblyToSubAssembly: true,
                });
            }
        });
    }

    const partFamilies = {};
    const individualParts = [];

    if (partsToAssemblies && Array.isArray(partsToAssemblies)) {
        partsToAssemblies.forEach((item) => {
            if (!item) return;

            if (item.partFamilyId) {
                if (!partFamilies[item.partFamilyId]) {
                    partFamilies[item.partFamilyId] = {
                        familyId: item.partFamilyId,
                        familyName: item.partFamilyName,
                        familyDescription: item.partFamilyDescription,
                        familyImageURL: item.partFamilyImageURL,
                        parts: [],
                    };
                }
                partFamilies[item.partFamilyId].parts.push(item);
            } else {
                individualParts.push(item);
            }
        });
    }

    Object.values(partFamilies).forEach((family) => {
        family.parts.sort((a, b) => (a.order || 0) - (b.order || 0));
    });

    individualParts.forEach((item) => {
        if (item && item.id) {
            groupedItems.push({
                ...item,
                itemType: 'part',
                dragId: item.id,
            });
        }
    });

    Object.values(partFamilies).forEach((family) => {
        if (family && family.familyId && family.parts && family.parts.length > 0) {
            groupedItems.push({
                itemType: 'family',
                dragId: `family-${family.familyId}`,
                familyId: family.familyId,
                familyName: family.familyName,
                familyDescription: family.familyDescription,
                familyImageURL: family.familyImageURL,
                parts: family.parts,
                order: family.parts.length > 0 ? family.parts[0].order || 0 : 0,
            });
        }
    });

    return groupedItems.sort((a, b) => (a.order || 0) - (b.order || 0));
}
